export default __webpack_public_path__ + "static/media/package.87258177.svg";